export class Subscription {
  channel: string;
  id: string;
  storeIdentifier: string;
  constructor(obj?: any) {
    if (obj) Object.assign(this, obj);
  }
}
